module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_link_external.svg?40ba3bcbd229e877c283a30e29b083e9";